import { render } from "./ProductsCreate.vue?vue&type=template&id=08594f07&scoped=true"
import script from "./ProductsCreate.vue?vue&type=script&lang=js"
export * from "./ProductsCreate.vue?vue&type=script&lang=js"

import "./ProductsCreate.vue?vue&type=style&index=0&id=08594f07&lang=css"
import "./ProductsCreate.vue?vue&type=style&index=1&id=08594f07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08594f07"]])

export default __exports__